import { render, staticRenderFns } from "./EditServiceItemTable.vue?vue&type=template&id=668b397b&scoped=true"
import script from "./EditServiceItemTable.vue?vue&type=script&lang=js"
export * from "./EditServiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./EditServiceItemTable.vue?vue&type=style&index=0&id=668b397b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b397b",
  null
  
)

export default component.exports